<script>
export default {
  functional: true,
  props: {
    level: {type: [Number, String], default: 0},
    size: {
      type: String,
      default: '',
    },
  },
  render: function(h, context) {
    const baseClass = 'heading';
    const tag = context.props.level ? `h${context.props.level}` : `p`;
    const sizeVariant = context.props.size ? `${baseClass}--${context.props.size.toLowerCase()}` : '';

    context.data.class = [baseClass, sizeVariant, context.data.class].join(' ');

    return h(tag, context.data, context.children);
  },
};
</script>
